import { render, staticRenderFns } from "./title-style.vue?vue&type=template&id=dcee3a9e&scoped=true&"
import script from "./title-style.vue?vue&type=script&lang=ts&"
export * from "./title-style.vue?vue&type=script&lang=ts&"
import style0 from "./title-style.vue?vue&type=style&index=0&id=dcee3a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcee3a9e",
  null
  
)

export default component.exports